import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';

import { installationsQuery, setCurrentOrgStorage } from '@/services/org';

export const Route = createFileRoute('/_authed/_layout/$owner')({
  beforeLoad: async ({ context: { queryClient }, params: { owner } }) => {
    const installations = await queryClient.ensureQueryData(installationsQuery());
    const installation = installations.find((i) => i.account.login === owner);
    if (!installation) {
      throw notFound();
    }
    setCurrentOrgStorage(installation);
    return { installation };
  },
  notFoundComponent: () => (
    <div className="flex h-full items-center justify-center">
      Not found. Check that you have the correct URL and that you and Mesa have access to the resource in GitHub.
    </div>
  ),
  component: () => <Outlet />,
});
